export default __webpack_public_path__ + "static/flag(ES)-5399741c6f0109f01162f09fd448e079.svg";